import styled from 'styled-components';
import { Base } from 'styled/components/base';
import { Color } from 'styled/theme/colors';

interface Props {
  textColor: Color;
}

interface LinkProps extends Props {
  isActive: boolean;
  textColorActive: Color;
}

export const ListItem = styled(Base)``;

export const Label = styled(Base)<Props>`
  white-space: nowrap;
  ${({ theme }) => theme.transitions['transition']};
  ${({ theme, textColor }) =>
    theme.hoverStyles.linkBorderBottomHidden(textColor)};
`;

export const StyledLink = styled(Base)<LinkProps>`
  white-space: nowrap;
  ${({ theme }) => theme.typography.variants.primary.xs};
  line-height: 0.875rem;
  color: ${({ isActive, textColor, textColorActive }) =>
    isActive ? textColorActive : textColor};

  :hover {
    ${Label} {
      ${({ theme, textColor, isActive }) =>
        !isActive && theme.hoverStyles.linkBorderBottom(textColor)};
    }
  }
`;

export const Arrow = styled(Base)<Props>`
  ${({ theme }) => theme.typography.variants.primary.xs};
  line-height: 0.875rem;
  color: ${({ textColor }) => textColor};
`;
